import {componentLoader, componentConfig} from "../../../lib/component_initializer";
import {InquiryFormConfig, InquiryForm} from "./inquiry_form";

export const inquiryFormLoader = function (options = {}) {
    componentLoader(componentConfig(InquiryForm, InquiryFormConfig.componentTypeKey, InquiryFormConfig.baseHtmlClass), options);
};

